import styles from "./ConsensusCell.module.scss";
import { classNames } from "@/lib/utils";
import CellTooltip from "./CellTooltip";

type Rating = [number | null, number | null];

const RATINGS = [
    { label: "Sell", className: styles.sell },
    { label: "Hold", className: styles.hold },
    { label: "Buy", className: styles.buy },
];

interface ConsensusCellProps {
    data: Rating[];
    tooltip: boolean;
    onClick?: () => void;
}

/** Analyst sell/hold/buy counts as one bar, each segment sized by its share of the ratings. */
const ConsensusCell = ({ data, tooltip, onClick }: ConsensusCellProps) => {
    const counts = RATINGS.map((rating, i) => ({ ...rating, now: data?.[i]?.[0] ?? 0, before: data?.[i]?.[1] ?? null }));
    const changes = counts.filter(({ now, before }) => before !== null && before !== now);
    const rated = counts.filter(({ now }) => now > 0);
    const summary = counts.map(({ label, now }) => `${label} ${now}`).join(" · ");
    const was = counts.map(({ label, now, before }) => `${label} ${before ?? now}`).join(" · ");

    return (
        <CellTooltip arrow title={tooltip ? (changes.length ? `${summary} (was ${was})` : summary) : undefined}>
            <div className={styles.ConsensusCell} onClick={onClick} style={{ cursor: onClick ? "pointer" : "inherit" }}>
                {rated.length ? (
                    <div className={styles.bar} role="img" aria-label={summary}>
                        {rated.map(({ label, className, now }) => (
                            <span key={label} className={className} style={{ flexGrow: now }}>
                                {now}
                            </span>
                        ))}
                    </div>
                ) : (
                    <p className={styles.none}>N/A</p>
                )}
                {changes.length > 0 && (
                    <div className={styles.changes}>
                        {changes.map(({ label, now, before }) => (
                            <span key={label} className={classNames(label === "Sell" ? now > before! && styles.down : label === "Buy" && now > before! && styles.up)}>
                                {`${label} ${now > before! ? "+" : "-"}${Math.abs(now - before!)}`}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </CellTooltip>
    );
};

export default ConsensusCell;
